export * from './allFaces';
export * from './ComposableTask';
export * from './ComputeFaceDescriptorsTasks';
export * from './detectFaces';
export * from './DetectFacesTasks';
export * from './DetectFaceLandmarksTasks';
export * from './FaceMatcher';
export * from './nets';
//# sourceMappingURL=index.js.map